class ScrollableTable {
    constructor(element) {
        if (!element) return

        this.element = element

        this._wrapElement()
    }

    _wrapElement() {
        $(this.element).wrap("<div class='table-wrap'></div>")
    }
}

export default ScrollableTable
